import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'
import { 
  LayoutDashboard, Building2, Users, Wallet, Gift, 
  BarChart3, LogOut, Menu, X 
} from 'lucide-react'
import { useState } from 'react'
import clsx from 'clsx'

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/companies', icon: Building2, label: 'Companies' },
  { to: '/employees', icon: Users, label: 'Employees' },
  { to: '/funding', icon: Wallet, label: 'Funding' },
  { to: '/rewards', icon: Gift, label: 'Rewards' },
  { to: '/reports', icon: BarChart3, label: 'Reports' }
]

export default function Layout() {
  const { admin, logout } = useAuthStore()
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="min-h-screen flex bg-gray-50">
      {/* Mobile sidebar backdrop */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={clsx(
        'fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transform transition-transform lg:transform-none',
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      )}>
        <div className="p-4 border-b border-gray-100 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://pay.heysalad.cash/HeySalad%20Logo%20Black.png" 
              alt="HeySalad" 
              className="h-8"
            />
            <span className="font-semibold text-gray-900">Admin</span>
          </div>
          <button className="lg:hidden text-gray-500" onClick={() => setSidebarOpen(false)}>
            <X size={20} />
          </button>
        </div>

        <nav className="p-4 space-y-1">
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) => clsx(
                'flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all font-medium',
                isActive 
                  ? 'bg-heysalad-500 text-white shadow-sm' 
                  : 'text-gray-600 hover:bg-gray-100'
              )}
            >
              <Icon size={20} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-100">
          <div className="text-sm text-gray-500 mb-1">{admin?.name || 'Admin'}</div>
          <div className="text-xs text-gray-400 mb-3">{admin?.email}</div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 text-gray-500 hover:text-heysalad-500 transition-colors text-sm"
          >
            <LogOut size={16} />
            Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-4 lg:hidden">
          <button onClick={() => setSidebarOpen(true)} className="text-gray-600">
            <Menu size={24} />
          </button>
          <img 
            src="https://pay.heysalad.cash/HeySalad%20Logo%20Black.png" 
            alt="HeySalad" 
            className="h-6"
          />
        </header>

        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
